module.exports = __webpack_public_path__ + "img/targeting_rounded.de0ac82.svg";